import { Injectable, Injector } from '@angular/core';
import { BaseState } from 'src/app/common/base/base.state'; import { Action, Selector, State, StateContext } from '@ngxs/store';
import { TransactionLogRefresh } from './transaction-log.action';
import { TransactionLog } from 'src/app/services/logs/transaction-logs';
import { TransactionLogService } from 'src/app/services/logs/transaction-log.service';

export class TransactionLogStateModel {
  data: TransactionLog[] = [];
}

@State<TransactionLogStateModel>({
  name: 'TransactionLog',
  defaults: {
    data: []
  }
})
@Injectable()
export class TransactionLogState extends BaseState {
  constructor(
    protected override injector: Injector,
    private _service: TransactionLogService

  ) {
    super(injector);
  }

  @Selector()
  static read(state: TransactionLogStateModel) {
    return state.data;
  }

  @Action(TransactionLogRefresh)
  refresh({ patchState }: StateContext<TransactionLogStateModel>, { serialNo }: TransactionLogRefresh) {
    this._service.GetBySerialNo(serialNo).subscribe(
      data => patchState({ data }),
      error => console.error(error)
    );
  }

}
